import React, { useMemo } from 'react';
import { useLoggedInUser, useFeatureFlags } from '@tcc/shared-data-lib';
import { importFromS3 } from '../../utils/importFromS3';
import { Operation } from '../../hooks/useOperations/types';
import { useUserLoggedInConfigs, useFeatureFlagsConfigs } from '../../utils/sharedData';
import { useImpersonatedOperation } from '../../hooks/useImpersonatedOperation';


type PluginProps = {
  operations: Operation[];
};

const S3Plugin = React.lazy(() => importFromS3('dashboard'));

export const DashboardPluginContainer = ({ operations }: PluginProps) => {
  const { user } = useLoggedInUser(useUserLoggedInConfigs);
  const { featureFlags } = useFeatureFlags(useFeatureFlagsConfigs(user));
  const useModuleFederation = featureFlags['web.dashboard.module-federation'];

  const DashboardPlugin = useMemo(() => {
    if (useModuleFederation) {
      return React.lazy(() => import('dashboard/Dashboard'));
    }
    return S3Plugin;
  }, [useModuleFederation]);

  const { operation: impersonatedOperation } = useImpersonatedOperation();
  const selectedOperations = useMemo(() => impersonatedOperation
    ? [impersonatedOperation]
    : [operations[1]], [impersonatedOperation, operations]);

  return <DashboardPlugin operations={selectedOperations} />;
};
